import { Pipe, PipeTransform } from '@angular/core';
import * as luxon from 'luxon';

const DateTime = luxon.DateTime;

@Pipe({ name: 'atTime' })
export class AtTimePipe implements PipeTransform {
  constructor() {}

  transform(value: string): string | null {
    const date = DateTime.fromISO(value, { zone: 'utc' }).toLocal();
    if (date < DateTime.now()) {
      return date.toFormat('hh:mm a');
    } else {
      return 'Just now';
    }
  }
}
